module.exports = __webpack_public_path__ + "static/media/p52_table_maxButton.3159e7a0.svg";